import React, { useEffect } from 'react';
import { Card, ApplicantExamDetailsTabs } from 'components';
import { connect } from 'react-redux';
import { Dispatch, IRootState } from '../../redux/store/configureStore';
import { push } from 'connected-react-router';
import { AppType } from 'components/enums';
import { useLocalErrorHandler } from 'hooks';

const ApplicantExamTabsContainer = ({
    setErrorHandler,
    examApplicationId,
    applicantDetail,
    applicationDetails,
    examDetails,
    examId,
    onPush,
    apiError,
    tab,
}: Props) => {
    useLocalErrorHandler(setErrorHandler);

    useEffect(() => {
        if (tab !== 'exam-details') {
            onPush(`/applicant-details/exam/${examId}/${examApplicationId}/exam-details`);
        }
    }, []);

    const handleClickBack = () => {
        const urlParams = new URLSearchParams(window.location.search);
        const from = urlParams.get('from');
        const nTab = from || 'qualifications';
        if (!applicantDetail) {
            if (from === 'exam-payment') {
                onPush(`/exam/${examId}?from=exam-payment`);
            }
        } else {
            onPush(`/applicant-details/${applicantDetail.id}/${nTab}`);
        }
    };

    return (
        <Card
          title="Информация по экзамену"
          category={applicationDetails ? `${applicationDetails.applicant.lastName} ${applicationDetails.applicant.firstName} ${applicationDetails.applicant.middleName}` : ''}
          cardClassName="position-relative"
          onClickBack={handleClickBack}
          apiError={apiError}
          withoutBorder
          withoutPadding
          withBackButton
        >
            {examDetails && applicationDetails ? (
                <ApplicantExamDetailsTabs
                  appType={AppType.Ec}
                  examDetails={examDetails}
                  examApplication={applicationDetails}
                  resultAndStatusCardCategory={null}
                  resultAndStatusCardTitle={null}
                  withoutExpertsTab
                  withoutInfoTab
                  withoutRulesTab
                />
            ) : null}
        </Card>
    );
};

const mapState = (state: IRootState) => ({
    examDetails: state.exam.examDetails,
    applicationDetails: state.examApplications.applicationDetails,
    applicantDetail: state.applicants.applicantDetail,
    apiError: state.errors.error,
});

const mapDispatch = (dispatch: Dispatch) => ({
    onPush: (key: string) => dispatch(push(key)),
    // onFetchExamDetails: (examId: string) => dispatch.exam.fetchExamDetailsAsync(examId),
    // getApplicantDetails: (payload: IGetApplicantDetailProps) => dispatch.applicants.getApplicantAsync(payload),
    setErrorHandler: dispatch.errors.setErrorHandler,
});

export default connect(mapState, mapDispatch)(ApplicantExamTabsContainer);

interface SelfProps {
    examId: string;
    examApplicationId: string;
    tab: string;
}

type Props = ReturnType<typeof mapState> & ReturnType<typeof mapDispatch> & SelfProps;
